import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import { Fold } from "../Fold";

export const TopicTypes = ({ types, reload }) => {
  const [fams, setFams] = useState([]);
  const [label, setLabel] = useState("");
  const [pick, setPick] = useState(["intro", "booking"]);
  useEffect(() => { http.get("/topics/types").then((r) => setFams(r.data.families)).catch(() => {}); }, []);
  const name = Object.fromEntries(fams.map((f) => [f.key, f.label]));
  const add = async () => {
    try { await http.post("/topics/types", { label, families: pick }); setLabel(""); setPick(["intro", "booking"]); toast.success("Type added"); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (k) => { try { await http.delete(`/topics/types/${k}`); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Fold id="topic-types" title={`Kit types (${types.length})`}>
      <div data-testid="topic-types-panel" className="mb-6 rounded-lg border border-stone-200 bg-white p-4">
        <ul className="mb-4 space-y-1 text-sm">
          {types.map((t) => (
            <li key={t.key} data-testid={`topic-type-${t.key}`} className="flex flex-wrap items-center gap-2">
              <b className="text-[#2B2A26]">{t.label}</b>
              <span className="text-xs text-stone-500">{t.families.map((f) => name[f] || f).join(" · ")}</span>
              <button data-testid={`topic-type-delete-${t.key}`} onClick={() => window.confirm(`Remove the "${t.label}" type?`) && del(t.key)} className="text-stone-400 hover:text-red-600"><X size={13} /></button>
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap items-center gap-2">
          <input data-testid="topic-type-label" value={label} onChange={(e) => setLabel(e.target.value)} placeholder="New type, e.g. Family"
            className="w-56 rounded-sm border border-stone-300 px-3 py-1.5 text-sm focus:border-[#C9A847] focus:outline-none" />
          {fams.map((f) => (
            <label key={f.key} className="inline-flex items-center gap-1 text-xs text-stone-600">
              <input data-testid={`topic-type-family-${f.key}`} type="checkbox" checked={pick.includes(f.key)}
                onChange={(e) => setPick(e.target.checked ? [...pick, f.key] : pick.filter((x) => x !== f.key))} /> {f.label}
            </label>
          ))}
          <button data-testid="topic-type-add" disabled={!label.trim() || !pick.length} onClick={add}
            className="inline-flex items-center gap-1 rounded-sm bg-[#2B2A26] px-3 py-1.5 text-xs font-bold text-white hover:bg-black disabled:opacity-40"><Plus size={12} /> Add type</button>
        </div>
        <p className="mt-2 text-xs text-stone-500">Pick which chapters a type includes. Chapters follow the edition (e.g. Wineries only appear in Wine Edition kits); "Important Information" is always added.</p>
      </div>
    </Fold>
  );
};
